module.exports = __webpack_public_path__ + "static/img/technologybimg4.a7402b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coreValues/technologybimg4.jpg
// module id = j+93
// module chunks = 2